import {
	Box,
	Button,
	Typography,
	Paper,
	IconButton, CircularProgress
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import dayjs from "dayjs";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import useUserAction from "../../hooks/user/useUserAction";
import useUserData from "../../hooks/user/useUserData";
import { getRouteUrl } from "../../helpers/routing/getRouteUrl";
import { getEndPoint } from "../../helpers/constants";
import {ROUTE_NEW_APPLICATION, ROUTE_PAGE_UPLOAD} from "../../routers/routes";
import { PAGE_APPLICATIONS } from "../../locales/pages/namespaces";
import LanguageSelect from "../../components/app/languageSelect/languageSelect";
import {useParams} from "react-router";
import {useUser} from "../../userContext/userContext";
import Images from "../../assets";

const Applications = () => {
	const {campaign} = useParams()
	const { t } = useTranslation(PAGE_APPLICATIONS);
	const { token } = useUserData();
	const { userLogout } = useUserAction();
	const history = useHistory();
	const {setReqId} = useUser()
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setIsLoading(true);
		axios.post(getEndPoint("requests"),
			{
				applicant_id: token,
				org_subprogramarea: campaign == '30years'? 2 : 1,
			})
			.then(res => {
				setData(res.data);
				setIsLoading(false);
			})
			.catch(err => {
				enqueueSnackbar(t("Failed loading requests"), { variant: "error" });
				setIsLoading(false);
			});
	}, []);

	return (
		<Box
			sx={{
				width: 800,
				margin: "0 auto",
				mt: 8,
				mb: 8,
				borderRadius: "30px",
				overflow: "hidden",
				boxShadow: "0px 40px 40px rgba(0,0,0,0.4)",
				background: "rgba(255,255,255,0.05)",
				backdropFilter: "blur(10px)",
			}}
		>
			<Box
				sx={{
					background: "#fff",
					height: 110,
					borderRadius: "30px 30px 0 0",
					px: 4,
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center"
				}}
			>

				{/*<Box */}
				{/*	sx={{ */}
				{/*		width: 260, */}
				{/*		height: 28, */}
				{/*		background: "linear-gradient(90deg,#004B88 10%,#007FBD 58%,#009DDC 90%)", */}
				{/*		borderRadius: 1*/}
				{/*}}*/}
				{/*/>*/}
				<Box
					component="img"
					src={Images.bigLogoNew}
					alt="logo"
					sx={{
						display:'flex',
						width: "50%",
						height:'50%'
					}}
				/>
				<Box sx={{display:'flex'}}>
					<LanguageSelect color={'#000000'}/>
					<IconButton
						onClick={userLogout}
						sx={{
							border: "1px solid #DCDCDC",
							width: 32,
							height: 32,
							borderRadius: "50%",
						}}
					>
						<LogoutIcon sx={{ fontSize: 16, color: "#004B88" }} />
					</IconButton>
				</Box>
			</Box>

			{/* CONTENT AREA */}
			<Box sx={{ p: 5 }}>
				<Typography
					sx={{
						fontSize: 24,
						fontWeight: 700,
						color: "#fff",
						mb: 4
					}}
				>
					{t("Request history")}
				</Typography>


				{!isLoading && data.map((item, idx) => (
					<Box
						key={idx}
						sx={{
							border: "1px solid rgba(255,255,255,0.4)",
							borderRadius: "3px",
							background: "rgba(0,0,0,0.15)",
							p: 3,
							mb: 2,
							color: "#fff",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center"
						}}
					>
						<Typography>{dayjs(item.reqdate).format("DD MMM YYYY")}</Typography>
						<Typography>{item.request_number}</Typography>
						{
							item.fileupload === 1 ?
								<Button
									variant="contained"
									onClick={() => {
										console.log('id',item.id)
										setReqId(item.id)
										history.push(getRouteUrl(ROUTE_PAGE_UPLOAD, {campaign}))
									}}
									sx={{
										textTransform: "none",
										fontWeight: 700,
										color: "#004B88",
										background: "#fff",
										border: "1px solid #DCDCDC",
									}}
								>
									{t('File upload')}
								</Button>
								:	<Typography sx={{ fontWeight: 700 }}>
									{t("The application has been successfully registered")}
								</Typography>

						}

					</Box>
				))}
				{isLoading && (
					<Box
						sx={{
							position: "absolute",
							inset: 0,
							background: "rgba(255,255,255,0.6)",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							borderRadius: 2,
						}}
					>
						<CircularProgress size={40} />
					</Box>
				)}

				<Button
					fullWidth
					variant="contained"
					onClick={() => history.push(getRouteUrl(ROUTE_NEW_APPLICATION,{campaign}))}
					sx={{
						mt: 4,
						height: 44,
						textTransform: "none",
						fontWeight: 700,
						color: "#004B88",
						background: "#fff",
						border: "1px solid #DCDCDC",
					}}
				>
					{t("New application")}
				</Button>
			</Box>
		</Box>
	);
};

export default Applications;
